// This is an example file and is expected to be cloned
// without the -example on the same folder that it resides.


// THE CODE BELOW IS COMMENTED OUT BECAUSE THEY ARE JUST EXAMPLES

/*
import AppLoader from '@/app-loader'
import PluginExample from '@/plugins/plugin-example/plugin-example.js'

const appHooks = AppLoader.getInstance().appHooks

// When adding a hook, three parameters can be passed:
// the name of the hook (string) to be listened, the
// function to be run and the priority (number).

// Below are examples of hook event that happen in the app.
// Some behaviors of the app can be modified by changing the
// parameter value that is passed when the hook is run.

appHooks.add('appLoaded', (vueInstance) => {
  const pluginExample = new PluginExample(vueInstance)
  appHooks.attachPlugin(pluginExample, vueInstance)
  // Do something when the app is loaded
})
*/
